import { useContext } from "react";
import { UserContext } from "../contexts/UserContext";
import { DASHBOARD_PERMISSION_CODES, hasPermission } from "../permissions";
import { ACCESS_LEVEL } from "./useAccessLevel";
import useDashboardViewStore from "../stores/useDashboardViewStore";

// Resolves which dashboard renders at "/". A user with BOTH the school and
// teacher dashboard perms can switch between them via the header toggle (choice
// persisted in localStorage). Single-role users get their one view; users with
// neither get null (Home shows an empty state).
export default function useDashboardView() {
  const { user } = useContext(UserContext);
  const preference = useDashboardViewStore((s) => s.preference);
  const setView = useDashboardViewStore((s) => s.setPreference);

  const canSchool = hasPermission(user, DASHBOARD_PERMISSION_CODES.SCHOOL_VIEW);
  const canTeacher = hasPermission(user, DASHBOARD_PERMISSION_CODES.TEACHER_VIEW);
  const canSwitch = canSchool && canTeacher;

  let view = null;
  if (canSwitch) {
    view =
      preference === ACCESS_LEVEL.TEACHER
        ? ACCESS_LEVEL.TEACHER
        : ACCESS_LEVEL.SCHOOL;
  } else if (canSchool) {
    view = ACCESS_LEVEL.SCHOOL;
  } else if (canTeacher) {
    view = ACCESS_LEVEL.TEACHER;
  }

  return { view, canSwitch, setView };
}
